import React, { useState } from "react";
import { Users, Loader } from "lucide-react";
import { useApp } from "../context/AppContext";
import { APP_NAME, APP_VERSION, FONT_SIZES, FONT_FAMILY, ICON_SIZES } from "../constants/appConfig";
import { Card } from "../components/ui/Card";
import { FormInput } from "../components/ui/FormControls";

export const LoginView = () => {
  const { handleLogin, navigate, palette } = useApp();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loginError, setLoginError] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const onSubmit = async () => {
    if (!email.trim() || !password.trim()) {
      setLoginError("Email and password are required");
      return;
    }
    setLoginError("");
    setIsSubmitting(true);
    const result = await handleLogin(email.trim(), password);
    setIsSubmitting(false);
    if (result.success) {
      navigate("main");
    } else {
      setLoginError(result.error || "Login failed");
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") onSubmit();
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: palette.background,
        fontFamily: FONT_FAMILY,
      }}
    >
      <Card
        style={{ width: "min(420px, 90vw)", padding: 40, textAlign: "center" }}
      >
        <div
          style={{
            width: 64,
            height: 64,
            borderRadius: 16,
            margin: "0 auto 16px",
            background: palette.background,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Users size={ICON_SIZES.xxl} style={{ color: "#fff" }} />
        </div>
        <h1
          style={{
            margin: "0 0 4px",
            fontSize: FONT_SIZES.xxl,
            color: palette.text1,
          }}
        >
          {APP_NAME}
        </h1>
        <div style={{ marginBottom: 28 }} />
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: 16,
            marginBottom: 24,
          }}
          onKeyDown={handleKeyDown}
        >
          <FormInput
            label="Email"
            value={email}
            onChange={setEmail}
            placeholder="you@example.com"
            type="email"
          />
          <FormInput
            label="Password"
            value={password}
            onChange={setPassword}
            type="password"
            placeholder="Enter password"
          />
        </div>
        {loginError && (
          <p
            style={{
              color: "#ef4444",
              fontSize: FONT_SIZES.sm,
              marginBottom: 16,
            }}
          >
            {loginError}
          </p>
        )}
        <button
          onClick={onSubmit}
          disabled={isSubmitting}
          style={{
            width: "100%",
            padding: 12,
            borderRadius: 10,
            background: isSubmitting ? palette.text3 : palette.background,
            color: "#fff",
            border: "none",
            fontSize: FONT_SIZES.md,
            fontWeight: 600,
            fontFamily: FONT_FAMILY,
            cursor: isSubmitting ? "wait" : "pointer",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: 8,
            opacity: isSubmitting ? 0.7 : 1,
            transition: "opacity 0.2s",
          }}
        >
          {isSubmitting && (
            <Loader
              size={ICON_SIZES.sm}
              style={{ animation: "spin 1s linear infinite" }}
            />
          )}
          {isSubmitting ? "Signing in..." : "Sign In"}
        </button>
        <div
          style={{
            marginTop: 24,
            paddingTop: 16,
            borderTop: `1px solid ${palette.cardBorder}`,
          }}
        >
          <div
            style={{
              fontSize: FONT_SIZES.xs,
              color: palette.text3,
              lineHeight: 1.5,
            }}
          >
            v{APP_VERSION}
          </div>
          <div
            style={{
              fontSize: FONT_SIZES.xs,
              color: palette.text3,
              marginTop: 4,
            }}
          >
            © {new Date().getFullYear()} ClearView Development Platform. All
            rights reserved.
          </div>
        </div>
      </Card>
      <style>{`@keyframes spin { from { transform: rotate(0deg); } to { transform: rotate(360deg); } }`}</style>
    </div>
  );
};
